/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CouponRestrictions,
    CouponRestrictionsFromJSON,
    CouponRestrictionsFromJSONTyped,
    CouponRestrictionsToJSON,
} from './CouponRestrictions';

/**
 * 
 * @export
 * @interface CouponUpdateParams
 */
export interface CouponUpdateParams {
    /**
     * 
     * @type {string}
     * @memberof CouponUpdateParams
     */
    id: string;
    /**
     * A value that shows whether a coupon is enabled and can no longer be redeemed
     * @type {boolean}
     * @memberof CouponUpdateParams
     */
    is_enabled: boolean;
    /**
     * An object containing directions for what this coupon will apply discounts to.
     * @type {any}
     * @memberof CouponUpdateParams
     */
    applies_to?: any;
    /**
     * A value that determines whether the coupon is added if the order meets restrictions.
     * @type {boolean}
     * @memberof CouponUpdateParams
     */
    apply_automatically?: boolean;
    /**
     * Timestamp specifying the first time at which the coupon can be redeemed. Before the redeem_after date, the coupon can not be applied.
     * @type {Date}
     * @memberof CouponUpdateParams
     */
    redeem_after?: Date;
    /**
     * Timestamp specifying the last time at which the coupon can be redeemed. After the redeem_before date, the coupon can no longer be applied to new customers.
     * @type {Date}
     * @memberof CouponUpdateParams
     */
    redeem_before?: Date;
    /**
     * 
     * @type {CouponRestrictions}
     * @memberof CouponUpdateParams
     */
    restrictions?: CouponRestrictions;
}

export function CouponUpdateParamsFromJSON(json: any): CouponUpdateParams {
    return CouponUpdateParamsFromJSONTyped(json, false);
}

export function CouponUpdateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponUpdateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'is_enabled': json['is_enabled'],
        'applies_to': !exists(json, 'applies_to') ? undefined : json['applies_to'],
        'apply_automatically': !exists(json, 'apply_automatically') ? undefined : json['apply_automatically'],
        'redeem_after': !exists(json, 'redeem_after') ? undefined : (new Date(json['redeem_after'])),
        'redeem_before': !exists(json, 'redeem_before') ? undefined : (new Date(json['redeem_before'])),
        'restrictions': !exists(json, 'restrictions') ? undefined : CouponRestrictionsFromJSON(json['restrictions']),
    };
}

export function CouponUpdateParamsToJSON(value?: CouponUpdateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'is_enabled': value.is_enabled,
        'applies_to': value.applies_to,
        'apply_automatically': value.apply_automatically,
        'redeem_after': value.redeem_after === undefined ? undefined : (value.redeem_after.toISOString()),
        'redeem_before': value.redeem_before === undefined ? undefined : (value.redeem_before.toISOString()),
        'restrictions': CouponRestrictionsToJSON(value.restrictions),
    };
}

